import React, { Component } from "react";
import { message } from "antd";
import { Redirect } from "react-router-dom";
import Fetch from "../../utils/fetch";
import { capchaKey } from "../../config";
import ReCAPTCHA from "react-google-recaptcha";
import Otpinput from "../../components/OtpInput";
import styles from "./login.module.scss";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      OTP: "",
      password: "",
      login: false,
      showOTP: false,
      submitButtonDisableState: false
    };
    this.recaptchaRef = React.createRef();
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  handleSubmit = async () => {
    this.recaptchaRef.current.execute();
  };

  handleCaptchaChange = async value => {
    const { emailId, password } = this.state;
    if (!emailId) {
      return message.error("Email ID field is required");
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailId)) {
      return message.error("Invalid Email ID");
    }

    if (value) {
      this.setState({ captchaValue: value });
    } else {
      message.error("ReCAPTCHA verification failed");
    }

    const path = `/user/login`;
    const options = {
      method: "post",
      data: {
        password,
        emailId,
        captchaValue: value
      }
    };

    const response = await Fetch(path, options);
    if (response) {
      this.setState({ showOTP: true, user: response });
    }
  };

  hideOtp = () => {
    this.setState({ showOTP: false });
  };

  verifyOTP = async data => {
    const url = `/user/LoginOtp`;

    const options = {
      method: "post",
      data
    };

    const response = await Fetch(url, options);
    if (response && response.idToken) {
      localStorage.setItem("idToken", response.idToken);
      this.setState({ login: true });
    } else {
      const { user } = this.state;
      user.noOfWrongAttempt = user.noOfWrongAttempt
        ? user.noOfWrongAttempt + 1
        : 1;
      this.setState({ showOtpError: true, user });
    }
  };

  render() {
    const {
      emailId,
      login,
      showOTP,
      showOtpError,
      user = {},
      password
    } = this.state;

    if (login) {
      const { location } = this.props;

      if (location.state) {
        const { from } = location.state;
        return <Redirect to={from} />;
      } else {
        return <Redirect to="/" />;
      }
    }

    return (
      <div className={styles.loginDiv}>
        <div className={styles.mainBody}>
          <div className="container">
            <div className="row">
              <div
                className={`col-md-6 col-12 ${styles.loginBlock} text-center`}
              >
                <h1 className="mb-5 text-left">Login</h1>

                {showOTP ? (
                  <Otpinput
                    isEmail={true}
                    totalOtp={6}
                    emailId={emailId}
                    userDetails={user}
                    hideOtp={this.hideOtp}
                    resendOtp={this.handleSubmit}
                    showOtpError={showOtpError}
                    verifyOTP={this.verifyOTP}
                  />
                ) : (
                  <>
                    <p>To continue login with your email</p>

                    <input
                      type="text"
                      name="emailId"
                      inputMode="text"
                      placeholder="Enter Email ID"
                      autoComplete="off"
                      value={emailId}
                      onChange={e => {
                        this.handleChange("emailId", e.target.value);
                      }}
                    />

                    <input
                      type="password"
                      name="password"
                      inputMode="text"
                      placeholder="Enter Password"
                      autoComplete="off"
                      value={password}
                      style={{ marginTop: "10px" }}
                      onChange={e => {
                        this.handleChange("password", e.target.value);
                      }}
                    />

                    <button onClick={this.handleSubmit}>Proceed</button>
                  </>
                )}
              </div>

              <div className={`col-6 d-none d-md-block ${styles.bgLogin}`} />
            </div>
          </div>
        </div>

        <ReCAPTCHA
          ref={this.recaptchaRef}
          sitekey={capchaKey}
          onChange={this.handleCaptchaChange}
          size="invisible"
        />
      </div>
    );
  }
}

export default Login;
